// 1. 외부 패키지
import { useRecoilValue } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import Skeleton from "../skeleton";
import media_atom from "../../atom/media-atom";

// 4. 타입

const MobileBottomCardSkeleton = () => {

	const media = useRecoilValue(media_atom);

	if(media === "P" || media === "T") return <></>

	return (
		<div className='mobile_register_card'>
			<Skeleton width={'100%'} height={208} />
		</div>
	);
};

export default MobileBottomCardSkeleton;